import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrintsAndStickersRoutingModule} from "./prints-and-stickers-routing.module";
import {GalleryModule} from "../../../galery/gallery.module";
import {PrintsAndStickersComponent} from "./prints-and-stickers.component";

@NgModule({
  declarations: [
    PrintsAndStickersComponent
  ],
  imports: [
    CommonModule,
    GalleryModule,
    PrintsAndStickersRoutingModule
  ]
})
export class PrintsAndStickersModule {
}
